import * as yup from "yup";
import { UNIT_TYPES } from "../constants/constants";
import { t } from "../../../../utils/translate"; 
import { useSelector } from "react-redux";
import { useMemo } from "react";

const priceValidation = yup
  .string()
  .test("is-number", (value) => t("price_validation_01")) 
  .test("is-positive", (value) => t("price_validation_02"));

const createPricesSchema = () => {
  const priceSchema = {};
  UNIT_TYPES.forEach((unit) => {
    priceSchema[unit] = priceValidation;
  });
  return yup.object().shape(priceSchema);
};

export const useScaffoldSchema = () => {
  const currentLanguage = useSelector((state) => state?.global?.current_language);

  return useMemo(
    () =>
      yup.object().shape({
        scaffoldName: yup
          .string()
          .required(t("scaffold_validation_01"))  
          .min(3, t("scaffold_validation_02"))
          .max(50, t("scaffold_validation_03")),
        prices: createPricesSchema().test(
          "at-least-one-price",
          t("scaffold_validation_04", { lng: currentLanguage }),
          (values) => Object.values(values).some((value) => value !== "")
        ),
      }),
    [currentLanguage] 
  );
};
